

























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('cases');

/* ----------------------------------------
   Features
---------------------------------------- */

import Bullets from '@part/features/Bullets';

/* ----------------------------------------
    Cards
---------------------------------------- */

import Case from '@part/cards/Case';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            picked: 'all'
        }
    },

    components: {
        Bullets,
        Case
    },

    props: {
        filter: Boolean,
        type: String
    },

    computed: {
        style() {
            return 'cases__container--' + this.type;
        },
        projects() {
            return module.getters('getCaseByDisciplines', this.picked)
        }
    },

    methods: {
        filteredProjects: function(value) {
            this.picked = value;
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Work extends Vue {}

